import SentimentTrackerOnboardingOverviewContainer from 'containers/SentimentTracker/SentimentTrackerOnboardingOverview';
import React from 'react';
// import OnestockOnboardingOverviewContainer from 'containers/JarvisOnestock/OnestockOnboardingOverview'

const SentimentTrackerOnboardingOverview = () => {
    return (
        <>
            <SentimentTrackerOnboardingOverviewContainer />
        </>);
}

export default SentimentTrackerOnboardingOverview;